import uniqueId from 'lodash/uniqueId'
import { StrictMode, useMemo, useRef } from 'react'
import type { VFC } from 'react'
import { Theme } from '@opallabs/gem'
import {
  InputLabel,
  DeprecatedSingleSelect,
  DeprecatedSingleSelectOption,
} from '@opallabs/lapidary'
import { Layout, LayoutGlyph } from '../../types'
import { humanizeSystemName } from '../section_helpers'
import * as styles from '../styles'
import type { SidebarProps } from '../types'

const glyphForValue = (name: Layout): string => LayoutGlyph[name]

export type Props = Pick<SidebarProps, 'layout' | 'theme'> &
  Readonly<{
    onChange(value: Layout): void
  }>

export const LayoutSection: VFC<Props> = ({
  layout = Layout.Text,
  onChange,
  theme = 'light',
}) => {
  const htmlId = useRef(uniqueId('sidebar-slide-layout'))

  const options: Array<DeprecatedSingleSelectOption> = useMemo(
    () =>
      Object.values(Layout).map((value) => ({
        value,
        label: humanizeSystemName(value),
        leadingIcon: {
          glyph: glyphForValue(value),
          visibility: 'always',
          useHypernova: true,
        },
      })),
    []
  )

  return (
    <StrictMode>
      <InputLabel
        inputId={htmlId.current}
        styleOverrides={styles.label(theme as Theme)}
        text="Layout"
        theme={theme}
      />

      <DeprecatedSingleSelect
        initialSelection={options.find((option) => option.value === layout)}
        options={options}
        onChange={(option) => option && onChange(option.value as Layout)}
        styleOverrides={{ zIndex: 4 }}
      />
    </StrictMode>
  )
}
LayoutSection.displayName = 'Hubble: LayoutSection ← Sidebar ← SlideEditor'
